import { memo } from 'react';

import { type Skill } from './skillTypes';

export type SkillExplanationProps = {
  skill: Pick<Skill, 'description' | 'name'>;
};

export const SkillExplanation = memo(({ skill }: SkillExplanationProps) => (
  <>
    <p className="mb-1 font-semibold text-12">{skill.name}</p>
    <p className="font-normal text-12 text-gray-10">{skill.description}</p>
  </>
));

SkillExplanation.displayName = 'SkillExplanation';
